import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';

import { FiltersControlsProps } from '../FiltersControls/FiltersControls';
import { FiltersControls } from '../FiltersControls';
import { Typography } from '../Typography/Typography';

import s from './styles.module.scss';

interface HeaderLink {
  name: string;
  href: string;
}

interface AddButtonProps {
  link: HeaderLink;
}

export const AddButton = ({ link }: AddButtonProps) => (
  <Link
    style={{
      display: 'flex',
      gap: '2px',
      marginLeft: 'auto',
      background: '#1976D2',
      height: '38px',
      width: 'fit-content',
      padding: '6px 16px 6px 10px',
      borderRadius: '4px',
      alignItems: 'center',
    }}
    to={link.href}
  >
    <AddIcon sx={{ width: '20px', height: '20px', fill: 'white' }} />
    <Typography component="p" fontSize="0.9735rem" fontWeight={500} lineHeight="26px" color="white">
      {link.name}
    </Typography>
  </Link>
);

interface ListHeaderProps {
  filters?: FiltersControlsProps;
  link?: HeaderLink | ReactNode;
  additional?: ReactNode;
}

/** @deprecated Используйте ListHeaderV2 */
export const ListHeader = ({ filters, additional, link }: ListHeaderProps) => (
  <header className={s.header}>
    {filters && <FiltersControls {...filters} />}

    {link || additional ? (
      <div className={s.buttons}>
        {additional ? additional : null}
        {link && (
          <>
            {React.isValidElement(link) ? (
              link
            ) : typeof link === 'object' && 'href' in link && 'name' in link ? (
              <AddButton link={link as HeaderLink} />
            ) : null}
          </>
        )}
      </div>
    ) : null}
  </header>
);


